import React, {useState, useEffect} from 'react'
import { Navbar, Nav, NavDropdown, Button } from "react-bootstrap"
import {  NavLink } from 'react-router-dom'
import { useUser } from '../../context/UserProvider'
import logo_ula_blanco from "./../../assets/images/ulagos_bco-11.png"
import {useHistory} from "react-router-dom"
import { logoutUser } from '../../services/auth.service'
const NavBarUser = () => {
  const { user, logout } = useUser()
	const history = useHistory()
	const [formaIngreso, setFormaIngreso] = useState("")

	useEffect(() => {
		setFormaIngreso(user.forma_ingreso)
	})

  return (
		<Navbar bg="dark" variant="dark" expand="lg">
			<Navbar.Brand href="#home">
				<img
					src={logo_ula_blanco}
					height="30"
					className="d-inline-block align-top mr-5"
					alt="React Bootstrap logo"
				/>
			</Navbar.Brand>
			{/* <Navbar.Brand>Plataforma Votaciones Online</Navbar.Brand> */}
			<Navbar.Toggle aria-controls="basic-navbar-nav" />
			<Navbar.Collapse id="basic-navbar-nav">
				<Nav className="mr-auto">
					<NavLink className="nav-link" to="/votaciones">
						Votaciones
					</NavLink>
					<NavLink className="nav-link" to="/registro">
						Mis Votaciones
					</NavLink>
					{user.isTricel && (
						<NavLink className="nav-link" to="/tricel">
							TRICEL
						</NavLink>
					)}
					{/* TODO: do it better */}
					{(user.run == "18137900" || user.run == "17199690" || user.run == "18143361" || user.run == "13734886" || user.run == "13405528") && (
						<NavDropdown title="Administración" id="basic-nav-dropdown">
							<NavDropdown.Item onClick={() => history.push("/admin/unidades")}>
								Unidades
							</NavDropdown.Item>
							<NavDropdown.Item onClick={() => history.push("/admin/votacion")}>
								Periodos de Votación
							</NavDropdown.Item>
							{/* <NavDropdown.Item onClick={() => history.push("/admin/usuarios")}>
								Usuarios
							</NavDropdown.Item> */}
						</NavDropdown>
					)}
				</Nav>
				<Nav className="mr-5">
					<NavDropdown title={user.nombres + " " + user.paterno} id="basic-nav-dropdown">
						{formaIngreso === "cu" && (
							<NavDropdown.Item
								as={Button}
								href="https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout?redirect=https%3A%2F%2Felecciones.ulagos.cl"
								onClick={logoutUser}
							>
								Cerrar Sesión
							</NavDropdown.Item>
						)}
						{formaIngreso === "rg" && (
							<NavDropdown.Item
								onClick={logout}
							>
								Cerrar Sesión
							</NavDropdown.Item>
						)}
					</NavDropdown>
				</Nav>
			</Navbar.Collapse>
		</Navbar>
	)
}

export default NavBarUser
